/**
 * Extracts store username from public store routes and admin store QR routes.
 *
 * @param {string} pathname
 * @returns {string}
 */
const getStoreUsernameFromPathname = (pathname) => {
    if (!pathname) {
        return '';
    }

    const routePatterns = [
        /^\/store\/([^/]+)$/,
        /^\/store\/contact\/([^/]+)$/,
        /^\/store\/about\/([^/]+)$/,
        /^\/store\/qr\/([^/]+)$/,
        /^\/administration\/store\/qr\/([^/]+)$/,
    ];

    for (const pattern of routePatterns) {
        const match = pathname.match(pattern);

        if (match) {
            return match[1];
        }
    }

    return '';
};

export default getStoreUsernameFromPathname;
